import { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import { programarNotificacionesDiarias } from '../utils/notificacionesDiarias'
import Curriculo from './Curriculo'
import PaginaLeccion from './PaginaLeccion'
import ClasesEnVivo from './ClasesEnVivo'
import VideoForos from './VideoForos'
import RetoDiario from './RetoDiario'
import Diccionario from './Diccionario'
import JuegosHub from './JuegosHub'
import Worksheets from './Worksheets'
import Lecturas from './Lecturas'
import Progreso from './Progreso'
import Insignias from './Insignias'
import Ranking from './Ranking'
import SalaVideo from './SalaVideo'

const API = process.env.REACT_APP_API_URL

const COLORES = {
  PRE: '#94A3B8', A1: '#22C55E', A2: '#3B82F6', B1: '#8B5CF6',
  B2: '#F59E0B', C1: '#EF4444', C2: '#1B3A8C'
}
const EMOJIS = {
  PRE: '🔰', A1: '🌱', A2: '🚀', B1: '⚡', B2: '🔥', C1: '💎', C2: '👑'
}

const NAV = [
  { id: 'inicio',      ic: '🏠', es: 'Inicio',            en: 'Home'             },
  { id: 'curriculo',   ic: '📚', es: 'Curriculo',         en: 'Curriculum'       },
  { id: 'clases',      ic: '🎥', es: 'Clases en vivo',    en: 'Live Classes'     },
  { id: 'foros',       ic: '🎙', es: 'VideoForos',        en: 'VideoForums'      },
  { id: 'retos',       ic: '🔥', es: 'Retos diarios',     en: 'Daily Challenges' },
  { id: 'progreso',    ic: '📊', es: 'Mi progreso',       en: 'My Progress'      },
  { id: 'insignias',   ic: '🏅', es: 'Insignias',         en: 'Badges'           },
  { id: 'ranking',     ic: '🏆', es: 'Ranking',           en: 'Leaderboard'      },
  { id: 'diccionario', ic: '🔍', es: 'Diccionario',       en: 'Dictionary'       },
  { id: 'juegos',      ic: '🎮', es: 'EduNova Juegos',    en: 'EduNova Games'    },
  { id: 'worksheets',  ic: '📄', es: 'Worksheets',        en: 'Worksheets'       },
  { id: 'lecturas',    ic: '📖', es: 'Lecturas',          en: 'Reading'          },
]

const TEXTOS = {
  es: {
    hola: '¡Hola!', bienvenido: 'Bienvenido a EnglishBridge', xpTotales: 'XP totales',
    diasRacha: 'Dias de racha', leccionesCompletadas: 'Lecciones completadas',
    palabrasGuardadas: 'Palabras guardadas', retosCompletados: 'Retos completados',
    tuCurriculo: 'Tu curriculo A1-C2', verTodo: 'Ver todo →', cargando: 'Cargando...',
    retosHoy: 'Retos de hoy', verTodos: 'Ver todos →', retoDiario: 'Reto diario disponible',
    retoDesc: 'Aprende slang en ingles y gana insignias exclusivas', empezar: 'Empezar →',
    misInsignias: 'Mis Insignias', coleccionaInsignias: 'Colecciona insignias',
    insigniasDesc: 'Gana insignias completando retos, lecciones y mas', ver: 'Ver →',
    juegosTitulo: 'EduNova Juegos', aprendeJugando: 'Aprende jugando',
    juegosDesc: 'Trivia en ingles, verdadero o falso, gramatica y mas', jugar: 'Jugar →',
    lecturasTitulo: 'Lecturas', lecturasSubt: 'Trabalenguas, cuentos y proverbios',
    lecturasDesc: 'Practica tu comprension lectora y pronunciacion por nivel',
    worksheetsTitulo: 'Worksheets', worksheetsSubt: '18 worksheets disponibles',
    worksheetsDesc: 'Hojas de practica para cada nivel — PRE a C1. Descarga y practica offline.',
    rankingTitulo: 'Ranking', competeTitulo: 'Compite con otros estudiantes',
    competeDesc: 'Gana puntos con lecciones, examenes e insignias', verRanking: 'Ver ranking →',
    cambiarAvatar: 'Cambiar avatar', cerrarSesion: 'Cerrar sesion',
    seccionProximamente: 'Esta seccion estara disponible proximamente.'
  },
  en: {
    hola: 'Hello!', bienvenido: 'Welcome to EnglishBridge', xpTotales: 'Total XP',
    diasRacha: 'Streak days', leccionesCompletadas: 'Lessons completed',
    palabrasGuardadas: 'Saved words', retosCompletados: 'Challenges completed',
    tuCurriculo: 'Your A1-C2 curriculum', verTodo: 'See all →', cargando: 'Loading...',
    retosHoy: "Today's challenges", verTodos: 'See all →', retoDiario: 'Daily challenge available',
    retoDesc: 'Learn English slang and earn exclusive badges', empezar: 'Start →',
    misInsignias: 'My Badges', coleccionaInsignias: 'Collect badges',
    insigniasDesc: 'Earn badges by completing challenges, lessons and more', ver: 'View →',
    juegosTitulo: 'EduNova Games', aprendeJugando: 'Learn by playing',
    juegosDesc: 'English trivia, true or false, grammar and more', jugar: 'Play →',
    lecturasTitulo: 'Reading', lecturasSubt: 'Tongue twisters, stories and proverbs',
    lecturasDesc: 'Practice your reading comprehension and pronunciation by level',
    worksheetsTitulo: 'Worksheets', worksheetsSubt: '18 worksheets available',
    worksheetsDesc: 'Practice sheets for every level — PRE to C1. Download and practice offline.',
    rankingTitulo: 'Leaderboard', competeTitulo: 'Compete with other students',
    competeDesc: 'Earn points with lessons, tests and badges', verRanking: 'See leaderboard →',
    cambiarAvatar: 'Change avatar', cerrarSesion: 'Log out',
    seccionProximamente: 'This section will be available soon.'
  }
}

const BANDERAS = ['co', 'us', 'gb', 'ca', 'au', 'ie', 'nz', 'za']

const EMOJIS_AVATAR = [
  '😀', '🧑‍💻', '🧑‍🎓', '🦸', '🧑‍🎨', '👩‍🚀', '🧑‍🍳', '🧑‍🏫',
  '🐱', '🐶', '🦊', '🐼', '🦁', '🐨', '🐸', '🦉',
  '🐧', '🦄', '🌟', '🔥', '🎯', '📚', '🎸', '⚽'
]

// Valores por defecto mientras carga la informacion real desde la API
// (base de datos de EnglishBridge en Supabase — ver api/src/routes/curriculo.js y progreso.js)
const STATS_VACIAS = { xp_total: 0, racha_dias: 0, lecciones_completadas: 0, retos_completados: 0 }

// Nombres bonitos para el badge de plan (coinciden con los ids de Precios.jsx)
const NOMBRES_PLAN = { starter: 'Starter', plus: 'Plus', advanced: 'Advanced', mastery: 'Mastery' }

/* Hook simple para detectar si estamos en tamano movil */
function useEsMovil() {
  const [esMovil, setEsMovil] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth <= 820 : false
  )
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 820px)')
    const handler = e => setEsMovil(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])
  return esMovil
}

/* Avatar del usuario: muestra la foto subida si existe, si no el
   emoji elegido, y si no la inicial del email. */
function AvatarUsuario({ avatarEmoji, avatarUrl, email, size = 36, onClick }) {
  const base = {
    width: size, height: size, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: size * 0.42, fontWeight: 800, color: '#fff',
    marginBottom: '6px', overflow: 'hidden', flexShrink: 0,
    cursor: onClick ? 'pointer' : 'default',
    border: onClick ? '2px solid rgba(255,255,255,0.25)' : 'none'
  }

  if (avatarUrl) {
    return (
      <div style={{ ...base, background: '#E2E6F0' }} onClick={onClick} title={onClick ? 'Cambiar avatar / Change avatar' : undefined}>
        <img src={avatarUrl} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </div>
    )
  }

  const contenido = avatarEmoji || email?.[0]?.toUpperCase()
  return (
    <div style={{ ...base, background: 'var(--dorado)' }} onClick={onClick} title={onClick ? 'Cambiar avatar / Change avatar' : undefined}>
      {contenido}
    </div>
  )
}

/* Modal para elegir el avatar: un emoji del catalogo, o una foto
   propia subida a Supabase Storage. */
function ModalAvatar({ avatarEmojiActual, avatarUrlActual, idioma, onCerrar, onGuardarEmoji, onGuardarFoto }) {
  const [pestana,          setPestana]          = useState('emoji') // 'emoji' | 'foto'
  const [emojiElegido,     setEmojiElegido]     = useState(avatarEmojiActual || EMOJIS_AVATAR[0])
  const [archivo,          setArchivo]          = useState(null)
  const [previsualizacion, setPrevisualizacion] = useState(avatarUrlActual || null)
  const [subiendo,         setSubiendo]         = useState(false)
  const [errorFoto,        setErrorFoto]        = useState(null)

  const t = idioma === 'en'
    ? {
        titulo: 'Change avatar', elegir: 'Choose an emoji', guardar: 'Save avatar',
        tabEmoji: 'Emoji', tabFoto: 'Photo', subirFoto: 'Choose a photo', subir: 'Upload and save',
        subiendo: 'Uploading...', errorTamano: 'Image must be under 3MB.', errorTipo: 'Use a JPG, PNG, WEBP or GIF image.'
      }
    : {
        titulo: 'Cambiar avatar', elegir: 'Elige un emoji', guardar: 'Guardar avatar',
        tabEmoji: 'Emoji', tabFoto: 'Foto', subirFoto: 'Elige una foto', subir: 'Subir y guardar',
        subiendo: 'Subiendo...', errorTamano: 'La imagen debe pesar menos de 3MB.', errorTipo: 'Usa una imagen JPG, PNG, WEBP o GIF.'
      }

  function alElegirArchivo(e) {
    const f = e.target.files?.[0]
    setErrorFoto(null)
    if (!f) return
    if (!f.type.startsWith('image/')) { setErrorFoto(t.errorTipo); return }
    if (f.size > 3 * 1024 * 1024) { setErrorFoto(t.errorTamano); return }
    setArchivo(f)
    setPrevisualizacion(URL.createObjectURL(f))
  }

  async function subirFoto() {
    if (!archivo || subiendo) return
    setSubiendo(true)
    setErrorFoto(null)
    try {
      await onGuardarFoto(archivo)
    } catch (err) {
      setErrorFoto(err?.response?.data?.error || 'No se pudo subir la foto. Intenta de nuevo.')
    } finally {
      setSubiendo(false)
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
      onClick={onCerrar}>
      <div style={{ background: '#fff', borderRadius: 18, maxWidth: 380, width: '100%', padding: 28 }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
          <h3 style={{ fontSize: 18, fontWeight: 800, color: '#1A1A2E' }}>{t.titulo}</h3>
          <button onClick={onCerrar} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#9CA3AF' }}>✕</button>
        </div>

        <div style={{ display: 'flex', background: '#F0F2F8', border: '1px solid #E2E6F0', borderRadius: 10, overflow: 'hidden', marginBottom: 18 }}>
          <button onClick={() => setPestana('emoji')}
            style={{ flex: 1, padding: '8px 0', border: 'none', background: pestana === 'emoji' ? 'var(--azul)' : 'transparent',
              color: pestana === 'emoji' ? '#fff' : '#6B7280', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            😀 {t.tabEmoji}
          </button>
          <button onClick={() => setPestana('foto')}
            style={{ flex: 1, padding: '8px 0', border: 'none', background: pestana === 'foto' ? 'var(--azul)' : 'transparent',
              color: pestana === 'foto' ? '#fff' : '#6B7280', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            📷 {t.tabFoto}
          </button>
        </div>

        {pestana === 'emoji' && (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#F8FAFF', border: '2px solid var(--azul)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28 }}>
                {emojiElegido}
              </div>
              <span style={{ fontSize: 12, color: '#6B7280' }}>{t.elegir}</span>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8,1fr)', gap: 6 }}>
              {EMOJIS_AVATAR.map(emoji => (
                <button key={emoji} onClick={() => setEmojiElegido(emoji)}
                  style={{ width: '100%', aspectRatio: '1', borderRadius: 8, border: '1.5px solid ' + (emojiElegido === emoji ? 'var(--azul)' : '#E2E6F0'),
                    background: emojiElegido === emoji ? '#EEF2FF' : '#fff', fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {emoji}
                </button>
              ))}
            </div>

            <button onClick={() => onGuardarEmoji(emojiElegido)}
              style={{ width: '100%', marginTop: 22, padding: '12px', background: 'var(--azul)', color: '#fff', border: 'none', borderRadius: 10, fontFamily: 'inherit', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
              {t.guardar}
            </button>
          </div>
        )}

        {pestana === 'foto' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
              <div style={{ width: 96, height: 96, borderRadius: '50%', background: '#F8FAFF', border: '2px solid var(--azul)', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {previsualizacion
                  ? <img src={previsualizacion} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  : <span style={{ fontSize: 32, color: '#9CA3AF' }}>📷</span>}
              </div>
            </div>

            <label style={{ display: 'block', textAlign: 'center', padding: '10px', borderRadius: 10, border: '1.5px dashed var(--azul)', color: 'var(--azul)', fontSize: 13, fontWeight: 700, cursor: 'pointer', marginBottom: 12 }}>
              {t.subirFoto}
              <input type="file" accept="image/*" onChange={alElegirArchivo} style={{ display: 'none' }} />
            </label>

            {errorFoto && (
              <p style={{ fontSize: 12, color: '#B91C1C', marginBottom: 10 }}>{errorFoto}</p>
            )}

            <button onClick={subirFoto} disabled={!archivo || subiendo}
              style={{
                width: '100%', padding: '12px', border: 'none', borderRadius: 10, fontFamily: 'inherit', fontSize: 14, fontWeight: 700,
                background: (!archivo || subiendo) ? '#9CA3AF' : 'var(--azul)', color: '#fff', cursor: (!archivo || subiendo) ? 'default' : 'pointer'
              }}>
              {subiendo ? t.subiendo : t.subir}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

/* Wordmark EnglishBridge, clickeable para volver al inicio */
function MarcaEnglishBridge({ onClick, size = 'normal' }) {
  const fontSize = size === 'small' ? 16 : 17
  return (
    <button onClick={onClick} title="EnglishBridge — inicio / home"
      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: 8, textAlign: 'left' }}>
      <img src="/englishbridge-logo.png" alt="EnglishBridge"
        style={{ width: size === 'small' ? 20 : 24, height: size === 'small' ? 20 : 24, objectFit: 'contain', flexShrink: 0 }} />
      <div style={{ fontSize, fontWeight: 900, letterSpacing: '-0.5px' }}>
        <span style={{ color: 'var(--dorado)' }}>English</span>
        <span style={{ color: '#7BA7E8' }}>Bridge</span>
      </div>
    </button>
  )
}

export default function Dashboard({ usuario, onLogout }) {
  const [pagina,        setPagina]        = useState('inicio')
  const [niveles,       setNiveles]       = useState([])
  const [cargando,      setCargando]      = useState(true)
  const [stats,         setStats]         = useState(STATS_VACIAS)
  const [palabrasCount,  setPalabrasCount] = useState(0)
  const [avatarEmoji,   setAvatarEmoji]   = useState(null)
  const [avatarUrl,     setAvatarUrl]     = useState(null)
  const [modalAvatar,   setModalAvatar]   = useState(false)
  const [menuAbierto,   setMenuAbierto]   = useState(false)
  const [idioma,        setIdioma]        = useState('es') // 'es' | 'en'
  const [curriculoKey,  setCurriculoKey]  = useState(0) // se incrementa para forzar refetch del curriculo
  const [leccionActiva, setLeccionActiva] = useState(null) // id de la leccion abierta, o null
  const [leccionMeta,   setLeccionMeta]   = useState({})   // { unidadId, unidadNombre, esUltimaLeccion }
  const [claseEnVideo,  setClaseEnVideo]  = useState(null) // id de la clase cuya videollamada esta abierta
  const [planInfo,      setPlanInfo]      = useState(null) // estado de la suscripcion (GET /pagos/estado)
  const esMovil = useEsMovil()
  const t = TEXTOS[idioma]

  const cargarDatos = useCallback(() => {
    if (!usuario?.id) { setCargando(false); return }
    setCargando(true)
    Promise.all([
      axios.get(`${API}/curriculo/niveles`),
      axios.get(`${API}/progreso/estadisticas/${usuario.id}`),
      axios.get(`${API}/diccionario/contador/${usuario.id}`)
    ]).then(([niv, est, dicc]) => {
      setNiveles(niv.data.datos || [])
      setStats(est.data.datos || STATS_VACIAS)
      setAvatarEmoji(est.data.avatar_emoji || null)
      setAvatarUrl(est.data.avatar_url || null)
      setPalabrasCount(dicc.data.total || 0)
    }).catch(err => {
      console.error('Error cargando datos del dashboard:', err)
    }).finally(() => setCargando(false))
  }, [usuario])

  useEffect(() => { cargarDatos() }, [cargarDatos])

  // Estado del plan/suscripcion: se pide aparte (no dentro de cargarDatos)
  // para que, si el sistema de pagos todavia no esta configurado o la
  // migracion de la base de datos no se ha corrido, el resto del
  // dashboard siga funcionando con normalidad.
  useEffect(() => {
    if (!usuario?.id) return
    axios.get(`${API}/pagos/estado/${usuario.id}`)
      .then(res => setPlanInfo(res.data?.datos || null))
      .catch(() => {})
  }, [usuario])

  // Notificaciones diarias de la app de celular: mindfulness (7 a. m.) y
  // mini-noticia en ingles (6 p. m.). En la pagina web no hace nada.
  useEffect(() => {
    if (usuario?.id) programarNotificacionesDiarias()
  }, [usuario])

  function irAPagina(id) {
    setPagina(id)
    if (esMovil) setMenuAbierto(false)
  }

  function unirseAClase(claseId) {
    setClaseEnVideo(claseId)
    irAPagina('sala-video')
  }

  function iniciarLeccion(leccionId, meta) {
    setLeccionActiva(leccionId)
    setLeccionMeta(meta || {})
    setPagina('leccion')
  }

  function volverDeLeccion() {
    setPagina('curriculo')
    setLeccionActiva(null)
    setLeccionMeta({})
    setCurriculoKey(k => k + 1) // fuerza a Curriculo.jsx a recargar progreso/XP actualizados
    cargarDatos() // refresca XP / lecciones completadas en el resto del dashboard
  }

  async function guardarAvatarEmoji(emoji) {
    setAvatarEmoji(emoji)
    setAvatarUrl(null)
    setModalAvatar(false)
    if (!usuario?.id) return
    try {
      await axios.put(`${API}/progreso/actualizar-avatar`, {
        usuario_id: usuario.id,
        avatar_emoji: emoji
      })
    } catch (err) {
      console.error('Error guardando avatar:', err)
    }
  }

  // Sube la foto elegida a Supabase Storage y la deja como avatar
  // activo. No atrapa sus propios errores: el modal los muestra.
  async function guardarAvatarFoto(archivo) {
    if (!usuario?.id) return
    const formData = new FormData()
    formData.append('usuario_id', usuario.id)
    formData.append('foto', archivo)

    const resSubida = await axios.post(`${API}/progreso/subir-avatar`, formData)
    const url = resSubida.data.avatar_url

    await axios.put(`${API}/progreso/actualizar-avatar`, {
      usuario_id: usuario.id,
      avatar_url: url
    })

    setAvatarUrl(url)
    setAvatarEmoji(null)
    setModalAvatar(false)
  }

  function renderContenido() {
    if (pagina === 'inicio') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '28px', flexWrap: 'wrap', gap: 12 }}>
            <div>
              <h1 style={{ fontSize: esMovil ? '22px' : '26px', fontWeight: 800 }}>{t.hola} 👋</h1>
              <p style={{ color: 'var(--gris-texto)', marginTop: '4px', fontSize: '14px', wordBreak: 'break-all' }}>
                {usuario?.email} · {t.bienvenido}
              </p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: esMovil ? '22px' : '28px', fontWeight: 800, color: 'var(--azul)' }}>
                ⚡ {(stats?.xp_total || 0).toLocaleString()}
              </div>
              <div style={{ fontSize: '11px', color: 'var(--gris-texto)' }}>{t.xpTotales}</div>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: esMovil ? 'repeat(2,1fr)' : 'repeat(4,1fr)', gap: '12px', marginBottom: '32px' }}>
            {[
              { ic: '🔥', num: stats?.racha_dias            || 0, label: t.diasRacha           },
              { ic: '📚', num: stats?.lecciones_completadas || 0, label: t.leccionesCompletadas },
              { ic: '📖', num: palabrasCount,                     label: t.palabrasGuardadas    },
              { ic: '🏆', num: stats?.retos_completados     || 0, label: t.retosCompletados     }
            ].map((s, i) => (
              <div key={i} style={{ background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: '14px', padding: '18px 12px', textAlign: 'center' }}>
                <div style={{ fontSize: '24px', marginBottom: '6px' }}>{s.ic}</div>
                <div style={{ fontSize: '26px', fontWeight: 800, color: 'var(--azul)' }}>{s.num}</div>
                <div style={{ fontSize: '12px', color: 'var(--gris-texto)', marginTop: '2px' }}>{s.label}</div>
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <h2 style={{ fontSize: '18px', fontWeight: 700 }}>{t.tuCurriculo}</h2>
            <button onClick={() => irAPagina('curriculo')}
              style={{ background: 'none', border: '1.5px solid var(--azul)', borderRadius: '8px', padding: '6px 16px', cursor: 'pointer', fontSize: '13px', fontFamily: 'inherit', color: 'var(--azul)', fontWeight: 600 }}>
              {t.verTodo}
            </button>
          </div>

          {cargando ? (
            <div style={{ textAlign: 'center', padding: '40px', color: 'var(--gris-texto)' }}>{t.cargando}</div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: esMovil ? '1fr' : 'repeat(3,1fr)', gap: '14px' }}>
              {niveles.map(n => (
                <div key={n.id} onClick={() => irAPagina('curriculo')}
                  style={{ background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: '14px', padding: '20px', cursor: 'pointer', transition: 'all .18s ease' }}
                  onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(27,58,140,.10)' }}
                  onMouseOut={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                    <span style={{ fontSize: '22px' }}>{EMOJIS[n.id]}</span>
                    <div>
                      <span style={{ background: COLORES[n.id], color: '#fff', fontSize: '11px', fontWeight: 800, padding: '2px 9px', borderRadius: '999px' }}>{n.id}</span>
                      <div style={{ fontSize: '14px', fontWeight: 700, marginTop: '2px' }}>{n.nombre}</div>
                    </div>
                    <span style={{ marginLeft: 'auto', fontSize: '13px', fontWeight: 700, color: 'var(--azul)' }}>0%</span>
                  </div>
                  <div style={{ height: '6px', background: 'var(--gris-borde)', borderRadius: '999px', overflow: 'hidden', marginBottom: '8px' }}>
                    <div style={{ width: '0%', height: '100%', background: COLORES[n.id], borderRadius: '999px' }} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: 'var(--gris-texto)' }}>
                    <span>{n.horas_totales}h</span>
                    <span>⚡ {n.xp_total.toLocaleString()} XP</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {[
            { key: 'retos',      pagina: 'retos',      emoji: '🔥', titulo: t.retosHoy,       gradiente: 'linear-gradient(135deg,#4F46E5,#7C3AED)', icono: '🏆', tituloTarjeta: t.retoDiario,       desc: t.retoDesc,        boton: t.empezar,   colorBoton: '#7C3AED' },
            { key: 'insignias',  pagina: 'insignias',  emoji: '🏅', titulo: t.misInsignias,   gradiente: 'linear-gradient(135deg,#92400E,#F59E0B)', icono: '🏅', tituloTarjeta: t.coleccionaInsignias, desc: t.insigniasDesc,   boton: t.ver,       colorBoton: '#F59E0B' },
            { key: 'juegos',     pagina: 'juegos',     emoji: '🎮', titulo: t.juegosTitulo,   gradiente: 'linear-gradient(135deg,#065F46,#059669)', icono: '🎮', tituloTarjeta: t.aprendeJugando,      desc: t.juegosDesc,      boton: t.jugar,     colorBoton: '#059669' },
            { key: 'lecturas',   pagina: 'lecturas',   emoji: '📖', titulo: t.lecturasTitulo, gradiente: 'linear-gradient(135deg,#0D1F52,#1B3A8C)', icono: '📖', tituloTarjeta: t.lecturasSubt,        desc: t.lecturasDesc,    boton: t.ver,       colorBoton: 'var(--azul)' },
            { key: 'worksheets', pagina: 'worksheets', emoji: '📄', titulo: t.worksheetsTitulo, gradiente: 'linear-gradient(135deg,#0D1F52,#1B3A8C)', icono: '📄', tituloTarjeta: t.worksheetsSubt,    desc: t.worksheetsDesc,  boton: t.ver,       colorBoton: 'var(--azul)' },
            { key: 'ranking',    pagina: 'ranking',    emoji: '🏆', titulo: t.rankingTitulo,  gradiente: 'linear-gradient(135deg,#92400E,#F59E0B)', icono: '🏆', tituloTarjeta: t.competeTitulo,       desc: t.competeDesc,     boton: t.ver,       colorBoton: '#F59E0B', botonVer: t.verRanking }
          ].map(sec => (
            <div key={sec.key} style={{ marginTop: 24 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                <h2 style={{ fontSize: '18px', fontWeight: 700 }}>{sec.emoji} {sec.titulo}</h2>
                <button onClick={() => irAPagina(sec.pagina)}
                  style={{ background: 'none', border: '1.5px solid ' + sec.colorBoton, borderRadius: '8px', padding: '6px 16px', cursor: 'pointer', fontSize: '13px', fontFamily: 'inherit', color: sec.colorBoton, fontWeight: 600 }}>
                  {sec.botonVer || t.verTodos}
                </button>
              </div>
              <div style={{ background: sec.gradiente, borderRadius: 14, padding: 20, color: '#fff', display: 'flex', alignItems: 'center', gap: 16, cursor: 'pointer', flexWrap: 'wrap' }}
                onClick={() => irAPagina(sec.pagina)}>
                <span style={{ fontSize: 48 }}>{sec.icono}</span>
                <div style={{ flex: 1, minWidth: 180 }}>
                  <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 4 }}>{sec.tituloTarjeta}</div>
                  <div style={{ fontSize: 13, opacity: .8 }}>{sec.desc}</div>
                </div>
                <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 10, padding: '8px 16px', fontSize: 13, fontWeight: 600 }}>
                  {sec.boton}
                </div>
              </div>
            </div>
          ))}
        </div>
      )
    }

    if (pagina === 'curriculo') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <Curriculo key={curriculoKey} usuario={usuario} onIniciarLeccion={iniciarLeccion} />
        </div>
      )
    }

    if (pagina === 'leccion' && leccionActiva) {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <PaginaLeccion
            leccionId={leccionActiva}
            usuario={usuario}
            unidadId={leccionMeta.unidadId}
            unidadNombre={leccionMeta.unidadNombre}
            esUltimaLeccion={leccionMeta.esUltimaLeccion}
            onVolver={volverDeLeccion}
          />
        </div>
      )
    }

    if (pagina === 'clases') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <ClasesEnVivo usuario={usuario} onUnirse={unirseAClase} />
        </div>
      )
    }

    if (pagina === 'foros') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <VideoForos usuario={usuario} />
        </div>
      )
    }

    if (pagina === 'sala-video') {
      return <SalaVideo usuario={usuario} claseId={claseEnVideo} onSalir={() => irAPagina('clases')} />
    }

    if (pagina === 'retos') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <RetoDiario usuario={usuario} />
        </div>
      )
    }

    if (pagina === 'diccionario') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <Diccionario usuario={usuario} onCambio={cargarDatos} />
        </div>
      )
    }

    if (pagina === 'juegos') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <JuegosHub usuario={usuario} onCambio={cargarDatos} />
        </div>
      )
    }

    if (pagina === 'worksheets') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <Worksheets usuario={usuario} onCambio={cargarDatos} />
        </div>
      )
    }

    if (pagina === 'lecturas') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <Lecturas usuario={usuario} onCambio={cargarDatos} />
        </div>
      )
    }

    if (pagina === 'progreso') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <Progreso usuario={usuario} />
        </div>
      )
    }

    if (pagina === 'insignias') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <Insignias usuario={usuario} />
        </div>
      )
    }

    if (pagina === 'ranking') {
      return (
        <div style={{ animation: 'fadeIn .3s ease both' }}>
          <Ranking usuario={usuario} />
        </div>
      )
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 20px', gap: '16px', color: 'var(--gris-texto)' }}>
        <span style={{ fontSize: '48px' }}>{NAV.find(n => n.id === pagina)?.ic}</span>
        <h2 style={{ fontSize: '22px', fontWeight: 700, color: 'var(--negro)' }}>{NAV.find(n => n.id === pagina)?.[idioma]}</h2>
        <p style={{ fontSize: '14px' }}>{t.seccionProximamente}</p>
      </div>
    )
  }

  const sidebarStyle = esMovil
    ? {
        width: '260px', background: 'var(--azul-oscuro)', padding: '20px 12px',
        display: 'flex', flexDirection: 'column', gap: '2px', position: 'fixed',
        top: 0, left: 0, height: '100vh', overflowY: 'auto', zIndex: 1500,
        transform: menuAbierto ? 'translateX(0)' : 'translateX(-100%)',
        transition: 'transform .25s ease', boxShadow: menuAbierto ? '4px 0 24px rgba(0,0,0,0.3)' : 'none'
      }
    : {
        width: '220px', background: 'var(--azul-oscuro)', padding: '20px 12px',
        display: 'flex', flexDirection: 'column', gap: '2px', position: 'fixed',
        top: 0, left: 0, height: '100vh', overflowY: 'auto'
      }

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>

      {modalAvatar && (
        <ModalAvatar
          avatarEmojiActual={avatarEmoji}
          avatarUrlActual={avatarUrl}
          idioma={idioma}
          onCerrar={() => setModalAvatar(false)}
          onGuardarEmoji={guardarAvatarEmoji}
          onGuardarFoto={guardarAvatarFoto}
        />
      )}

      {/* Header movil con boton hamburguesa */}
      {esMovil && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: 56, background: 'var(--azul-oscuro)',
          display: 'flex', alignItems: 'center', gap: 12, padding: '0 14px', zIndex: 1200, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
          <button onClick={() => setMenuAbierto(true)}
            style={{ background: 'none', border: 'none', color: '#fff', fontSize: 24, cursor: 'pointer', padding: 4 }}>
            ☰
          </button>
          <MarcaEnglishBridge onClick={() => irAPagina('inicio')} size="small" />
          <div style={{ flex: 1 }} />
          <AvatarUsuario avatarEmoji={avatarEmoji} avatarUrl={avatarUrl} email={usuario?.email} size={30} onClick={() => setModalAvatar(true)} />
        </div>
      )}

      {/* Backdrop oscuro al abrir el menu en movil */}
      {esMovil && menuAbierto && (
        <div onClick={() => setMenuAbierto(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1400 }} />
      )}

      <aside style={sidebarStyle}>

        <div style={{ padding: '0 8px 16px', borderBottom: '1px solid rgba(255,255,255,.1)', marginBottom: '8px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
          <div>
            <div style={{ marginBottom: '6px' }}>
              <MarcaEnglishBridge onClick={() => irAPagina('inicio')} />
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px', marginBottom: '6px' }}>
              {BANDERAS.map((codigo, i) => (
                <img key={i} src={`https://flagcdn.com/24x18/${codigo}.png`} alt={codigo}
                  style={{ width: 16, height: 12, borderRadius: 2, objectFit: 'cover', flexShrink: 0 }} />
              ))}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4, color: 'rgba(255,255,255,.4)', fontSize: '10px' }}>
              <img src="/edunova-logo.png" alt="" style={{ width: 12, height: 12, objectFit: 'contain', opacity: .7 }} />
              por EDUNOVA
            </div>
          </div>
          {esMovil && (
            <button onClick={() => setMenuAbierto(false)}
              style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.6)', fontSize: 20, cursor: 'pointer' }}>
              ✕
            </button>
          )}
        </div>

        {/* Selector de idioma ES / EN */}
        <div style={{ padding: '0 8px 14px', marginBottom: '8px', borderBottom: '1px solid rgba(255,255,255,.1)' }}>
          <div style={{ display: 'flex', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, overflow: 'hidden' }}>
            <button onClick={() => setIdioma('es')}
              style={{ flex: 1, padding: '7px 0', border: 'none', background: idioma === 'es' ? 'var(--dorado)' : 'transparent',
                color: idioma === 'es' ? '#fff' : 'rgba(255,255,255,.6)', fontFamily: 'inherit', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
              🇪🇸 ES
            </button>
            <button onClick={() => setIdioma('en')}
              style={{ flex: 1, padding: '7px 0', border: 'none', background: idioma === 'en' ? 'var(--dorado)' : 'transparent',
                color: idioma === 'en' ? '#fff' : 'rgba(255,255,255,.6)', fontFamily: 'inherit', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
              🇬🇧 EN
            </button>
          </div>
        </div>

        <div style={{ padding: '0 8px 16px', marginBottom: '8px', borderBottom: '1px solid rgba(255,255,255,.1)' }}>
          <AvatarUsuario
            avatarEmoji={avatarEmoji}
            avatarUrl={avatarUrl}
            email={usuario?.email}
            size={36}
            onClick={() => setModalAvatar(true)}
          />
          <div style={{ fontSize: '12px', color: 'rgba(255,255,255,.7)', wordBreak: 'break-all' }}>{usuario?.email}</div>
          <div style={{ fontSize: '11px', color: 'var(--dorado)', fontWeight: 700, marginTop: '2px' }}>
            ⚡ {(stats?.xp_total || 0).toLocaleString()} XP
          </div>
          {planInfo?.plan_actual && planInfo?.suscripcion_estado === 'activa' && (
            <div style={{ fontSize: '10.5px', color: 'rgba(255,255,255,.8)', marginTop: 4, background: 'rgba(255,255,255,0.1)', display: 'inline-block', padding: '2px 8px', borderRadius: 999 }}>
              🎫 Plan {NOMBRES_PLAN[planInfo.plan_actual] || planInfo.plan_actual}
            </div>
          )}
          <button onClick={() => setModalAvatar(true)}
            style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.5)', fontSize: '10px', cursor: 'pointer', padding: 0, marginTop: 4, textDecoration: 'underline' }}>
            {t.cambiarAvatar}
          </button>
        </div>

        {NAV.map(item => (
          <button key={item.id} onClick={() => irAPagina(item.id)}
            style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '11px 12px', borderRadius: '10px',
              background: pagina === item.id
                ? item.id === 'juegos' ? '#059669'
                : item.id === 'worksheets' || item.id === 'lecturas' ? 'var(--azul)'
                : item.id === 'ranking' || item.id === 'insignias' ? '#F59E0B'
                : 'var(--dorado)'
                : 'transparent',
              color: pagina === item.id ? '#fff' : 'rgba(255,255,255,.65)',
              border: 'none', fontFamily: 'inherit', fontSize: '14px',
              fontWeight: pagina === item.id ? 700 : 500,
              cursor: 'pointer', textAlign: 'left', width: '100%', transition: 'all .15s ease' }}>
            <span style={{ fontSize: '17px' }}>{item.ic}</span>
            <span>{item[idioma]}</span>
          </button>
        ))}

        <div style={{ marginTop: 'auto', paddingTop: '16px', borderTop: '1px solid rgba(255,255,255,.08)' }}>
          <button onClick={onLogout}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '11px 12px', border: 'none', borderRadius: '10px', background: 'transparent', color: 'rgba(255,255,255,.5)', fontFamily: 'inherit', fontSize: '14px', cursor: 'pointer', textAlign: 'left' }}>
            <span>🚪</span><span>{t.cerrarSesion}</span>
          </button>
        </div>
      </aside>

      <main style={{ flex: 1, marginLeft: esMovil ? 0 : '220px', marginTop: esMovil ? 56 : 0, padding: esMovil ? '20px 16px' : '32px', maxWidth: '1200px', width: esMovil ? '100%' : 'auto', boxSizing: 'border-box' }}>
        {renderContenido()}
      </main>
    </div>
  )
}
